import { render, staticRenderFns } from "./RejectedReasonModal.vue?vue&type=template&id=cb106ab0&"
import script from "./RejectedReasonModal.vue?vue&type=script&lang=js&"
export * from "./RejectedReasonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports